'use client';

export { default as useSlotProps } from '@mui/utils/useSlotProps';